<template>
    <div class="w-1200" style="padding-bottom: 60px;">
        <div class="font-24 mt-8 font-500 text-center">{{newsDetail.title}}</div>
        <div class="mt-8" style="width: 1200px;height: 10px;background: #F7F9FA;"></div>
        <div class="mt-8" v-html="newsDetail.content"></div>
    </div>
</template>

<script>
    export default {
        name: 'literature',
        data() {
            return {
                newsDetail: {}
            }
        },
        mounted() {
            this.getNewsDetail()
        },
        methods: {
            async getNewsDetail() {
                this.newsDetail = await this.$api.getNewsDetail({id:this.$route.query.id})
            },

        },

    }
</script>
<style scoped lang="scss">
    .item {
        position: relative;
        padding: 40px 0;

        &::after {
            position: absolute;
            content: '';
            width: 1200px;
            height: 1px;
            background: #DDDDDD;
            left: 0;
            bottom: 0;
        }
        &:last-child::after{
            height: 0;
        }

    }
</style>
